import type { ReactNode } from 'react';
import { CloudOff, RotateCcw } from 'lucide-react';
import { errorMessage } from '@/lib/api';
import { Button } from './Button';
import { EmptyState } from './EmptyState';

export interface ErrorStateProps {
  error: unknown;
  title?: ReactNode;
  description?: ReactNode;
  onRetry?: () => void;
  compact?: boolean;
}

/** 取得失敗時の表示。TanStack Query の error をそのまま渡せる */
export function ErrorState({ error, title = 'データを取得できませんでした', description, onRetry, compact }: ErrorStateProps) {
  return (
    <div role="alert">
      <EmptyState
        compact={compact}
        icon={<CloudOff />}
        title={title}
        description={description ?? (error ? errorMessage(error) : undefined)}
        action={
          onRetry && (
            <Button icon={<RotateCcw size={15} />} onClick={onRetry}>
              再読み込み
            </Button>
          )
        }
      />
    </div>
  );
}
